
const ContentTypes = {
  Tabs: 'Tabs',
  News: 'News',
  Home: 'Home',
  Carousel: 'Carousel',
  Grid: 'Grid',
  Human: 'Human',
  Accordion: 'Accordion',
  Partners: 'Partners',
  Vacancy: 'Vacancy',
  ShareButtons: 'Sharebuttons',
  Map: 'Map',
  SalesButton: 'Sales',
  PersonalVideo: 'Personal-video'
}

const NewsModes = {
  List: 'list',
  Details: 'details',
  LastNews: 'last-news'
}

const TabsModes = {
  Subpage: 'subpage',
  HtmlContent: 'html'
}

const VacancyModes = {
  List: 'list',
  Details: 'details'
}

const TabsOrientation = {
  Vertical: 'vertical',
  Horizontal: 'horizontal'
}

const PartnerTypes = {
  Partner: 'Partner',
  Client: 'Client'
}

const FormModes = {
  SaleForm: 'sale',
  FeedbackForm: 'feedback',
  TechSupportForm: 'techSupportForm',
  DeletePersonaInformationForm: 'deletePersonaInformationForm',
  ConsultationForm: 'consultationForm',
  RequestDraftAgreementForm: 'requestDraftAgreementForm',
}

const ErrorCodes = {
  FATALERROR: 'FATALERROR',
  INVALIDDATA: 'INVALIDDATA',
  INTERNETDISCONNECTED: 'INTERNETDISCONNECTED',

  FORBIDDEN: 'Forbidden',
  RESOURCENOTFOUND: 'NotFound'
}

const PageType = {
  Home: 'Home',
  Page: 'Page',
  Vacancy: 'Vacancy',
  News: 'News',
  TabList: 'TabList',
  Tab: 'Tab'
}

export {
  ContentTypes,
  NewsModes,
  ErrorCodes,
  TabsModes,
  TabsOrientation,
  VacancyModes,
  PartnerTypes,
  FormModes,
  PageType
}
